import { Clickable, Logo, Row, Text } from 'components';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import SocialLinks from '../SocialLinks';
import { Newsletter, SendUsAMessage } from './components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: black;
  align-items: center;

  @media (max-width: 1024px) {
    padding: 0 13px;
  }
`;

const ContentArea = styled.footer`
  padding: 113px 0 205px;
  width: 1140px;
  background-color: black;

  @media (max-width: 1024px) {
    padding: 37px 0 205px;
    width: 100%;
  }

  .header-text {
    font-size: 30px;
    font-weight: 500;

    @media (max-width: 1024px) {
      font-weight: 700;
      font-size: 18px;
    }
  }

  .newsletter-web {
    border-bottom: 0.5px solid #fff;
    padding-bottom: 4px;

    @media (max-width: 1024px) {
      display: none;
    }
  }

  .send-us-message {
    margin-top: 17px;
    p {
      font-size: 24px;

      @media (max-width: 1024px) {
        font-size: 16px;
      }
    }
  }

  .not-an-athlete-or-fan {
    margin-top: 48px;

    .header {
      font-size: 30px;
      font-weight: 500;
      color: white;

      @media (max-width: 1024px) {
        font-size: 18px;
        font-weight: 700;
      }
    }

    .content {
      font-size: 24px;
      color: white;
      margin-top: 17px;
      border-bottom: 0.5px solid #fff;
      padding-bottom: 4px;
      width: fit-content;

      @media (max-width: 1024px) {
        font-size: 16px;
        margin-top: 10px;
      }
    }
  }

  .newsletter-mobile {
    font-size: 16px;
    color: white;
    border-bottom: 0.5px solid #fff;
    padding-bottom: 4px;
    margin-top: 40px;
    width: fit-content;

    @media (min-width: 1024px) {
      display: none;
    }
  }

  .icons-holder {
    margin-top: 109px;
    width: 373px;

    @media (max-width: 1024px) {
      margin-top: 44px;
      width: 191px;
    }
  }

  .footer-navigator {
    margin-top: 113px;

    @media (max-width: 1024px) {
      margin-top: 43px;
    }
  }

  .signup {
    @media (max-width: 1024px) {
      margin: 30px 0 0;
    }
  }

  .web-extras {
    @media (max-width: 1024px) {
      margin: 30px 0 0;
    }
  }

  .mobile-copyright {
    margin: 50px 0 0;

    @media (min-width: 1024px) {
      display: none;
    }
  }
`;

const Footer = (props) => {
  const [visible, setVisible] = useState(false),
    user = useSelector((state) => state.user),
    { isMobile } = useSelector((state) => state.appState),
    navigate = useNavigate(),
    location = useLocation(),
    { t } = useTranslation();

  function handleVisible() {
    setVisible(!visible);
  }

  if (location.pathname.includes('admin')) return null;

  return (
    <React.Fragment>
      <SendUsAMessage visible={visible} closeModal={handleVisible} />
      <Wrapper>
        <ContentArea>
          <Row between center>
            <Text className="header-text" col="white">
              {t('website.connectWithUs')}
            </Text>

            {!isMobile && <Newsletter />}
          </Row>

          <div className="send-us-message">
            <Text col="white">{t('website.wedLoveTo')}</Text>

            <Text
              onClick={handleVisible}
              col="white"
              style={{
                borderBottom: '0.5px solid #fff',
                paddingBottom: 4,
                width: 'fit-content'
              }}
            >
              {t('website.sendUsAMessage')}
            </Text>
          </div>

          <div className="not-an-athlete-or-fan">
            <Text className="header">{t('website.notAnAthleteOrFan')}</Text>

            <Text className="content" onClick={handleVisible}>
              {t('website.connectWithUsHere')}
            </Text>
          </div>

          {isMobile && <Newsletter isMobile />}

          <SocialLinks />

          <div className="footer-navigator">
            <Row between mobileToTablet isColumn>
              <div>
                <Clickable onClick={() => navigate('/')}>
                  <Text size="24px" col="#fff" marg="0 0 10px">
                    {t('website.home')}
                  </Text>
                </Clickable>

                <Clickable onClick={() => navigate('athlete-zone')}>
                  <Text size="24px" col="#fff" marg="0 0 10px">
                    {t('website.athleteZoneSmall')}
                  </Text>
                </Clickable>

                <Clickable onClick={() => navigate('fan-zone')}>
                  <Text size="24px" col="#fff" marg="0 0 10px">
                    {t('website.fanZoneSmall')}
                  </Text>
                </Clickable>

                <Clickable onClick={() => navigate('our-athletes')}>
                  <Text size="24px" col="#fff" marg="0 0 10px">
                    {t('website.ourAthletesSmall')}
                  </Text>
                </Clickable>

                {/*
                  <Clickable onClick={() => navigate('news')}>
                    <Text size='24px' col='#fff' marg='0 0 10px'>{t('website.news')}</Text>
                  </Clickable>
                */}

                <Clickable onClick={() => navigate('our-story')}>
                  <Text size="24px" col="#fff" marg="0 0 10px">
                    {t('website.ourStorySmall')}
                  </Text>
                </Clickable>

                <Clickable onClick={() => navigate('partners-and-sponsors')}>
                  <Text size="24px" col="#fff" marg="0 0 10px">
                    {t('website.partnersAndSponsors')}
                  </Text>
                </Clickable>
              </div>

              <div className="signup">
                {
                  // TODO: Uncomment when content is ready
                  // <Text size='24px' col='#fff' marg='0 0 10px'>{t('website.selectCountry')}</Text>
                }

                {!user && (
                  <Clickable onClick={() => navigate('signup')}>
                    <Text size="24px" col="#fff" marg="0 0 10px">
                      {t('website.signUp')}
                    </Text>
                  </Clickable>
                )}
              </div>

              <div className="web-extras">
                <div>
                  <Clickable onClick={() => navigate('stop-the-hate')}>
                    <Text size="24px" col="#fff" marg="0 0 10px">
                      {t('website.stopTheHate')}
                    </Text>
                  </Clickable>

                  <Clickable onClick={() => navigate('terms-and-conditions')}>
                    <Text size="24px" col="#fff" marg="0 0 10px">
                      {t('website.termsAndConditions')}
                    </Text>
                  </Clickable>

                  <Clickable onClick={() => navigate('privacy-policy')}>
                    <Text size="24px" col="#fff" marg="0 0 10px">
                      {t('website.privacyPolicy')}
                    </Text>
                  </Clickable>

                  <Clickable onClick={() => navigate('child-safety-standard-policy')}>
                    <Text size="24px" col="#fff" marg="0 0 10px">
                      {t('website.childSafety')}
                    </Text>
                  </Clickable>

                  <Clickable onClick={() => navigate('community-guidelines')}>
                    <Text size="24px" col="#fff" marg="0 0 10px">
                      {t('website.communityGuidelines')}
                    </Text>
                  </Clickable>

                  <div style={{ margin: '50px 0 0' }}>
                    <Text size="24px" col="#fff" marg="0 0 10px">
                      {t('website.playaz4playaz')}
                    </Text>
                    <Text size="24px" col="#fff" marg="0 0 10px">
                      {t('website.allRigthsReserved')}
                    </Text>
                  </div>
                </div>
              </div>
            </Row>

            <div className="mobile-copyright">
              <Text size="24px" col="#fff" marg="0 0 10px">
                {t('website.playaz4playaz')}
              </Text>
              <Text size="24px" col="#fff" marg="0 0 10px">
                {t('website.allRigthsReserved')}
              </Text>
            </div>
          </div>

          <div style={{ marginTop: 96 }}>
            <Logo white />
          </div>
        </ContentArea>
      </Wrapper>
    </React.Fragment>
  );
};

export default Footer;
